define('models/strategyAudienceGroupedSegments',["jQuery", "T1", "Backbone", "T1Model", "T1Collection", "collections/strategyAudienceSegments"], function ($, T1, Backbone, T1Model, T1Collection, StrategyAudienceSegments) {
  T1.Models.StrategyTargetGroupedSegments = T1Model.extend({
    url: "strategies",
    fixture: "-strategy_target_groupedSegments",
    relations: [{
      type: Backbone.HasMany,
      key: "user_saved",
      relatedModel: "T1Model",
      collectionType: "StrategyAudienceSegments",
      includeInJSON: false
    }, {
      type: Backbone.HasMany,
      key: "partials",
      relatedModel: "T1Model",
      collectionType: "T1Collection",
      includeInJSON: false
    }],
    parse: function (data) {
      var result = {
        user_saved: [],
        partials: []
      };
      var topLevelEntityArr = data.entities || [];
      if (topLevelEntityArr && !$.isArray(topLevelEntityArr)) {
        topLevelEntityArr = [topLevelEntityArr];
      }
      $.each(topLevelEntityArr, function (index, entityGroup) {
        var resultEntities = T1Collection.prototype.parse({
          entities: entityGroup
        });
        if (entityGroup.set && entityGroup.set == "partial") {
          result.partials = resultEntities;
        } else {
          var tmpResult = [];
          var audience_segment;
          $.each(resultEntities, function (index, value) {
            if (value.audience_segment) {
              audience_segment = value.audience_segment;
              audience_segment.action = value.restriction === "INCLUDE" ? "include" : "exclude";
              audience_segment.user_cpm = value.user_cpm;
              audience_segment.group_identifier = value.group_identifier;
              audience_segment.operator = value.operator;
              tmpResult.push(audience_segment);
            }
          });
          result.user_saved = tmpResult;
        }
      });
      return result;
    },
    fetch: function (opts) {
      var args = opts || {};
      args.params = $.extend(true, {
        full: "*",
        partial: 1,
        with: "audience_segment",
        currency_code: opts.currency_code
      }, args.params || {});
      args.action = "audience_segments";
      T1Model.prototype.fetch.call(this, args);
    },
    canEdit: function () {
      var permissionDerferred = $.Deferred();
      permissionDerferred.resolve(true);
      return permissionDerferred.promise();
    }
  });
  return T1.Models.StrategyTargetGroupedSegments;
});
